import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Collapse } from 'antd';
import { firstLetterLowCase, checkFieldStatus } from '../../../../shared/helpers';
import { crud_options } from './statics';
import { editGroupModelPermissionsRequest } from '../redux/actions/edit_group_model_permissions.actions';

const mapStateToProps = (state) => {
    const { moduleOptionFields, url_active, group_id } = state.UserManagement.User_group_update;
    return { moduleOptionFields, url_active, group_id };
};

export default connect(mapStateToProps, null)(class GroupModelFields extends Component {
  editModelPermission = ({ target: { url, title, permissions } }) => {
      const status = title[0].toLowerCase();
      permissions.includes(status) ? permissions.splice(permissions.indexOf(status), 1) : permissions = [...permissions, status];
      this.props.dispatch(editGroupModelPermissionsRequest(url, permissions || [], 'field'));
  };

  render() {
      const { moduleOptionFields, url_active } = this.props;
      const buildGroupModelFieldsStructure = fields => (
          Object.keys(fields).map((field, index) => (
              fields[field].childFields
                  ? (
                      <Collapse key={index} className="sbf_collapse" style={{ marginBottom: 5 }}>
                          <Collapse.Panel
                              header={(
                                  <span style={fields[field].childFields && { marginLeft: '15px' }}>
                                      {fields[field].displayName || fields[field].fieldName}
                                  </span>
                              )}
                              key={fields[field].URL}
                          >
                              <div className="field_subschema">
                                  {`${fields[field].displayName || fields[field].fieldName} permissions`}
                                  <span>
                                      {crud_options.map((option, index) => (
                                          <Checkbox
                                              key={index}
                                              title={option.title}
                                              url={fields[field].URL}
                                              permissions={moduleOptionFields[url_active].modulesPermissions[fields[field].URL].permissions}
                                              onChange={this.editModelPermission}
                                              checked={checkFieldStatus(fields[field].crud, option, moduleOptionFields[url_active].modulesPermissions[fields[field].URL].permissions)}
                                              disabled={!fields[field].crud[firstLetterLowCase(option.title)]}
                                          >
                                              {option.title}
                                          </Checkbox>
                                      ))}
                                  </span>
                              </div>
                              {fields[field].childFields && buildGroupModelFieldsStructure(fields[field].childFields)}
                          </Collapse.Panel>
                      </Collapse>
                  )
                  : (
                      <div className="collapse_panel_inactive" key={index}>
                          <Fragment>
                              <span style={fields[field].childFields && { marginLeft: '15px' }}>{fields[field].displayName || fields[field].fieldName}</span>
                              <span style={{ float: 'right', paddingRight: '5px' }}>
                                  {crud_options.map((option, index) => (
                                      <Checkbox
                                          key={index}
                                          title={option.title}
                                          url={fields[field].URL}
                                          permissions={moduleOptionFields[url_active].modulesPermissions[fields[field].URL].permissions}
                                          onChange={this.editModelPermission}
                                          checked={checkFieldStatus(fields[field].crud, option, moduleOptionFields[url_active].modulesPermissions[fields[field].URL].permissions)}
                                          disabled={!fields[field].crud[firstLetterLowCase(option.title)]}
                                      >
                                          {option.title}
                                      </Checkbox>
                                  ))}
                              </span>
                          </Fragment>
                      </div>
                  )
          ))
      );
      if (moduleOptionFields && url_active && moduleOptionFields[url_active]) {
          return buildGroupModelFieldsStructure(moduleOptionFields[url_active].fields);
      }
      return <div style={{ textAlign: 'center', fontStyle: 'italic' }}>Select model to set permissions</div>;
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/GroupModelFields.js